import { ref } from 'vue'
import type { Ref } from 'vue'
import { FOOTER_APPS_MENU } from '../entities/MenuType'
import type { FooterAppsLinks } from '../entities/MenuFooterApps'
import { contentCall } from './useMenu'
import { useHeaderStore } from '~~/modules/api/stores/header'

export const useMenuFooterApps = async () => {
  const data = await contentCall(FOOTER_APPS_MENU, false)
  const dataAdapted: FooterAppsLinks = data
  const MenuFooterAppsInstance: Ref<FooterAppsLinks> = ref(dataAdapted)

  return { MenuFooterAppsInstance }
}

export const showMenuFooterApps = () => {
  const headerStore = useHeaderStore()
  return !headerStore.isApp
}
